export const nameValueArrayFromObject = (object) => {
    return Object.entries(object).map(([key, value]) => ({
        name: value,
        value: key,
    }));
};
export const objectToEnumObject = (object) => {
    return Object.keys(object).reduce((acc, key) => {
        acc[key] = key;
        return acc;
    }, {});
};
export const objectFlip = (obj) => {
    const ret = {};
    Object.keys(obj).forEach((key) => {
        ret[obj[key]] = key;
    });
    return ret;
};
//# sourceMappingURL=utils.js.map